"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundRedemptConfirmRequest = void 0;
var FundRedemptConfirmRequest = /** @class */ (function () {
    function FundRedemptConfirmRequest() {
    }
    return FundRedemptConfirmRequest;
}());
exports.FundRedemptConfirmRequest = FundRedemptConfirmRequest;
;
//# sourceMappingURL=fundRedemptConfirm.request.js.map